import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../services/api";
import "./addTeacher.css";

export default function AddTeacher() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [classes, setClasses] = useState([]);
  const [sectionsMap, setSectionsMap] = useState({});

  const [photo, setPhoto] = useState(null);
  const [preview, setPreview] = useState(null);

  // ================= FORM STATE =================
  const [form, setForm] = useState({
    teacher_id: "",
    teacher_password: "",
    name: "",
    email: "",
    phone: "",

    qualification: "",
    pf_number: "",
    aadhaar_number: "",

    joining_date: "",
    salary: "",
    address: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [assignments, setAssignments] = useState([
    {
      class_model: "",
      section: "",
      subject: "",
      is_class_teacher: false,
    },
  ]);

  const SUBJECTS = [
    // LANGUAGES
    "English",
    "Hindi",
    "Bengali",
    "Tamil",
    "Telugu",
    "Kannada",
    "Malayalam",
    "Marathi",
    "Punjabi",
    "Urdu",
    "Sanskrit",
    "French",
    "German",
    "Spanish",
    "Arabic",

    // CORE SUBJECTS
    "Math",
    "Science",
    "EVS",
    "Social Science",

    // SCIENCE STREAM
    "Physics",
    "Chemistry",
    "Biology",
    "Computer Science",
    "Computer Applications",
    "Information Technology",

    // SOCIAL STUDIES
    "History",
    "Geography",
    "Political Science",
    "Civics",
    "Economics",
    "Sociology",
    "Psychology",

    // COMMERCE
    "Accountancy",
    "Business Studies",
    "Commerce",
    "Entrepreneurship",

    // ARTS
    "Fine Arts",
    "Drawing",
    "Painting",
    "Music",
    "Dance",
    "Drama",
    "Craft",

    // SPORTS
    "Physical Education",
    "Yoga",
    "Sports",

    // TECHNICAL
    "Robotics",
    "Coding",
    "Artificial Intelligence",
    "Web Development",

    // GENERAL
    "GK",
    "Moral Science",
    "Environmental Science",
    "Library",
    "Life Skills",
    "Health Education",
  ];
  // ================= LOAD CLASSES =================
  const loadClasses = async () => {
    const res = await API.get("/school-admin/classes/", {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setClasses(res.data.classes);
  };

  // LOAD SECTIONS (CACHED)
  const loadSections = async (classId) => {
    if (!classId || sectionsMap[classId]) return;

    const res = await API.get(`/school-admin/sections/${classId}/`, {
      headers: { "X-SCHOOL-ID": school.school.id },
    });

    setSectionsMap((prev) => ({
      ...prev,
      [classId]: res.data.sections,
    }));
  };

  useEffect(() => {
    loadClasses();
  }, []);

  // ================= BASIC CHANGE =================
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ================= ASSIGNMENTS =================
  const updateAssignment = (index, key, value) => {
    const updated = [...assignments];
    updated[index][key] = value;

    if (key === "class_model") {
      updated[index].section = "";
      loadSections(value);
    }

    setAssignments(updated);
  };

  const addAssignment = () => {
    setAssignments([
      ...assignments,
      { class_model: "", section: "", subject: "", is_class_teacher: false },
    ]);
  };

  const removeAssignment = (index) => {
    if (assignments.length === 1) return;
    setAssignments(assignments.filter((_, i) => i !== index));
  };

  // ================= PHOTO =================
  const handlePhoto = (file) => {
    if (!file) return;
    setPhoto(file);
    setPreview(URL.createObjectURL(file));
  };

  // ================= SUBMIT =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (submitting) return;

    // Aadhaar validation
    if (form.aadhaar_number && form.aadhaar_number.length !== 12) {
      return alert("Aadhaar number must be 12 digits");
    }

    setSubmitting(true);

    try {
      // OPTIONAL ASSIGNMENTS
      const validAssignments = assignments.filter(
        (a) => a.class_model && a.section && a.subject,
      );

      const fd = new FormData();

      // BASIC FORM DATA
      Object.keys(form).forEach((k) => {
        if (form[k]) {
          fd.append(k, form[k]);
        }
      });

      // ASSIGNMENTS
      fd.append("assignments", JSON.stringify(validAssignments));

      // PHOTO
      if (photo) {
        fd.append("photo", photo);
      }

      await API.post("/school-admin/teachers/add/", fd, {
        headers: {
          "X-SCHOOL-ID": school.school.id,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Teacher added successfully!");

      navigate("/school-admin/teachers");
    } catch (err) {
      alert(
        err.response?.data?.error ||
          err.response?.data?.message ||
          "Failed to add teacher",
      );
    } finally {
      setSubmitting(false);
    }
  };
  return (

      <div className="teacher-add-page">
        <div className="teacher-add-hero">
          <div className="teacher-add-hero-left">
            <span className="teacher-add-hero-icon">👩‍🏫</span>
            <div>
              <h1>Add Teacher</h1>
              <p>Create faculty login, profile, salary data, and teaching assignments</p>
            </div>
          </div>

          <button
            type="button"
            className="teacher-add-back"
            onClick={() => navigate("/school-admin/teachers")}
          >
            Teacher List
          </button>
        </div>

      <div className="teacher-form-container">
        <form onSubmit={handleSubmit} className="teacher-form">
          <div className="teacher-form-grid">
            <aside className="teacher-photo-panel">
              <p className="teacher-panel-label">Teacher Photo</p>
              <div
                className="photo-upload-box"
                onClick={() => document.getElementById("teacherPhoto").click()}
              >
                {preview ? (
                  <img src={preview} className="preview-image" alt="Preview" />
                ) : (
                  <div className="teacher-upload-empty">
                    <span>👤</span>
                    <p>Upload Photo</p>
                  </div>
                )}
                <input
                  id="teacherPhoto"
                  type="file"
                  hidden
                  onChange={(e) => handlePhoto(e.target.files[0])}
                />
              </div>
              <p className="teacher-photo-note">
                Use a clear portrait for staff cards, profile pages, and records.
              </p>
            </aside>

            <div className="teacher-fields">

          <h3 className="section-title">Login & Profile</h3>
          <div className="teacher-section-card">
          {/* BASIC INFO */}
          <div className="form-group">
            <label>Teacher ID</label>
            <input name="teacher_id" onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input name="teacher_password" onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label>Full Name</label>
            <input name="name" onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input type="email" name="email" onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>Phone</label>
            <input name="phone" onChange={handleChange} />
          </div>
          </div>

          <h3 className="section-title">Official Details</h3>
          <div className="teacher-section-card">
          {/* OFFICIAL INFO */}
          <div className="form-group">
            <label>Qualification</label>
            <input
              name="qualification"
              placeholder="B.Ed / M.Sc / B.A"
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>PF Number</label>
            <input name="pf_number" onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>Aadhaar Number</label>
            <input
              name="aadhaar_number"
              maxLength="12"
              placeholder="12-digit Aadhaar"
              onChange={handleChange}
            />
          </div>
          </div>

          {/* ASSIGNMENTS */}
          <h3 className="section-title">Teaching Assignments</h3>
          <div className="teacher-section-card assignment-section-card">

          {assignments.map((a, idx) => (
            <div key={idx} className="assignment-card">
              <select
                value={a.class_model}
                onChange={(e) =>
                  updateAssignment(idx, "class_model", e.target.value)
                }
              >
                <option value="">Select Class</option>
                {classes.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name}
                  </option>
                ))}
              </select>

              <select
                value={a.section}
                onChange={(e) =>
                  updateAssignment(idx, "section", e.target.value)
                }
              >
                <option value="">Select Section</option>
                {(sectionsMap[a.class_model] || []).map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name}
                  </option>
                ))}
              </select>

              <select
                value={a.subject}
                onChange={(e) =>
                  updateAssignment(idx, "subject", e.target.value)
                }
              >
                <option value="">Select Subject</option>
                {SUBJECTS.map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </select>

              <label className="checkbox">
                <input
                  type="checkbox"
                  checked={a.is_class_teacher}
                  onChange={(e) =>
                    updateAssignment(idx, "is_class_teacher", e.target.checked)
                  }
                />
                Class Teacher
              </label>

              <button
                type="button"
                className="btn-remove"
                onClick={() => removeAssignment(idx)}
              >
                ✖
              </button>
            </div>
          ))}

          <button type="button" className="btn-add" onClick={addAssignment}>
            + Add Assignment
          </button>
          </div>

          <h3 className="section-title">Salary & Address</h3>
          <div className="teacher-section-card">
          {/* OTHER INFO */}
          <div className="form-group">
            <label>Joining Date</label>
            <input type="date" name="joining_date" onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>Salary</label>
            <input name="salary" onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>Address</label>
            <textarea name="address" onChange={handleChange}></textarea>
          </div>
          </div>

          <button className="btn-submit" disabled={submitting}>
            {submitting && <span className="button-loader"></span>}
            {submitting ? "Adding Teacher..." : "Add Teacher"}
          </button>
            </div>
          </div>
        </form>
      </div>
      </div>

  );
}
